// TSS vite/06 — dp versioning scheme. Newest entry first.
// Type enum: 'feature' | 'fix' | 'improvement' | 'breaking'.

const CHANGELOG = [
    {
        version: 'dp1.5',
        date: '2026-07-02',
        title: 'Liquidaciones: vista por cliente',
        notes: [
            { type: 'feature', text: 'El detalle de la liquidación mensual se puede ver “Por cliente”: cada cliente con sus vacas, su participación y su total, mucho más claro que la columna de reparto.' },
            { type: 'improvement', text: 'La vista “Por vaca” sigue disponible con un botón para alternar; el total del período cuadra con la suma por cliente.' },
        ],
    },
    {
        version: 'dp1.4',
        date: '2026-07-02',
        title: 'Ventas: plan de financiación, abonos y avisos de atraso',
        notes: [
            { type: 'feature', text: 'La venta lleva un plan de financiación de la cría: Nº de factura de compra, Nº y valor de cuota, y próxima fecha de vencimiento.' },
            { type: 'feature', text: 'Nuevo panel de Abonos por venta: historial de pagos con su medio (efectivo, transferencia, cheque…), registro de un abono y anulación.' },
            { type: 'feature', text: 'El listado de Ventas avisa cuándo una venta está “Atrasada” o “Requiere recálculo”, y muestra el vendedor y lo abonado.' },
            { type: 'improvement', text: 'Las acciones de cada venta (editar, abonos, reconciliar, anular) se agrupan en un menú de opciones para una tabla más limpia.' },
        ],
    },
    {
        version: 'dp1.3',
        date: '2026-07-02',
        title: 'Software Ganadero: navegador de vacas e historial',
        notes: [
            { type: 'feature', text: 'Navegador de vacas de Software Ganadero: una fila por vaca, con buscador.' },
            { type: 'feature', text: 'Detalle de la vaca con su historial por tipo de evento y línea de identidades.' },
            { type: 'feature', text: 'Gráficas de tendencia de leche y peso.' },
        ],
    },
    {
        version: 'dp1.2',
        date: '2026-07-01',
        title: 'Software Ganadero: subida de backups',
        notes: [
            { type: 'feature', text: 'Nueva vista Integraciones · Software Ganadero en /admin/sg: historial de backups de ingesta con estado, registros y tablas importadas' },
            { type: 'feature', text: 'Subida de backups .zip de Software Ganadero con arrastrar y soltar, progreso real de la carga y resumen del pipeline (ingesta → normalización → reconciliación)' },
            { type: 'feature', text: 'Detección de backups ya procesados (idempotencia) y aviso cuando el .zip no contiene tablas de Software Ganadero' },
        ],
    },
    {
        version: 'dp1.1',
        date: '2026-05-16',
        title: 'Example feature + SimpleCrud',
        notes: [
            { type: 'feature',     text: 'Nueva feature de ejemplo en /admin/example con CRUD completo (lista filtrada, crear, editar, eliminar)' },
            { type: 'feature',     text: 'Componente genérico SimpleCrud en common/components/ — listo para catálogos de tipo {id, name, description}' },
            { type: 'feature',     text: 'Página /admin/example/categories que demuestra el uso de SimpleCrud' },
            { type: 'improvement', text: 'Set inicial de iconos SVG en common/icons/ (Edit, Trash, Plus, Eye, EyeOff)' },
        ],
    },
    {
        version: 'dp1.0',
        date: '2026-05-15',
        title: 'Plantilla inicial',
        notes: [
            { type: 'feature', text: 'Esqueleto inicial conformante a TSS vite v1' },
        ],
    },
];

export default CHANGELOG;
